//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import update               from 'immutability-helper';
import { SmallScreenTypes } from '@/store/actions/smallScreen';

const initialState = {
    accepted: false,
};

const acceptSmallScreen = (action, state) => {
    return update(state, {
        accepted: {
            $set: true,
        },
    });
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // @formatter:off
        case SmallScreenTypes.SMALL_SCREEN_ACCEPTED: return acceptSmallScreen(action, state);
        default:                                     return state;
        // @formatter:on
    }
}
